/** @jsx jsx */

import { Fragment as _, useState, useContext } from 'react';
import { jsx } from '@emotion/core';
import { colors } from 'styles/variables';
import { FiveStarRatingContext } from './FiveStarRating_v2';

const { lGrey2 } = colors;

const Message = ({
  placeholder = 'Type your message here. . .',
  onUpdateCallback,
  style = {},
  ...props
}) => {
  const [hasValue, setHasValue] = useState(false);

  const onUpdate = useContext(FiveStarRatingContext)[onUpdateCallback];

  return (
    <textarea
      placeholder={placeholder}
      aria-label={placeholder}
      style={{
        width: '100%',
        padding: '10px 20px',
        fontFamily: 'inherit',
        fontSize: 16,
        fontWeight: 300,
        resize: 'none',
        // border: `1px solid ${lGrey2}`,
        textAlign: 'center',
        ...style,
      }}
      onFocus={e => {
        e.currentTarget.placeholder = '';
      }}
      onBlur={e => {
        if (!e.currentTarget.value) {
          e.currentTarget.placeholder = placeholder;
          e.currentTarget.style.textAlign = 'center';
        }
      }}
      onKeyUp={e => {
        const { value } = e.currentTarget;
        requestAnimationFrame(() => {
          if (!value) {
            setHasValue(false);
            return onUpdate('');
          }
        });

        if (value && !hasValue) setHasValue(true);

        onUpdate(value);
      }}
      // {...props}
    />
  );
};

export default Message;
